import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Zap, Sparkles, ArrowLeft, ShieldCheck } from "lucide-react";
import PageHead from "@/components/PageHead";
import PricingCards from "@/components/PricingCards";
import { useAuth } from "@/context/AuthContext";

export default function InPortalPricing() {
  const { user } = useAuth();

  return (
    <div className="space-y-8 pb-12">
      <PageHead
        label="Account & Wallet"
        title="Upgrade Plan & Top Up Credits"
        sub="Choose a monthly subscription or grab instant top-up credit packs to power your job search."
      >
        <Link
          to="/app/profile"
          className="cv-btn-ghost border border-border text-xs flex items-center gap-1.5"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> Back to Profile
        </Link>
      </PageHead>

      {/* Wallet Status Banner */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="rounded-2xl border border-electric/30 bg-gradient-to-r from-electric/10 via-violet/10 to-card p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 shadow-sm"
      >
        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-electric text-white shadow-glow">
            <Zap className="h-6 w-6 fill-white" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <span className="font-heading text-lg font-bold text-foreground">Current Balance:</span>
              <span className="font-heading text-xl font-black text-electric">
                {user?.credits ?? 0} Credits
              </span>
            </div>
            <p className="text-xs text-muted-foreground mt-0.5">
              Active Tier: <span className="font-semibold text-foreground">{user?.plan || "Free"}</span> · 90-day rollover validity on top-up packs
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 text-xs font-semibold text-muted-foreground border-t sm:border-t-0 sm:border-l border-border/80 pt-3 sm:pt-0 sm:pl-6">
          <ShieldCheck className="h-4 w-4 text-lime" />
          <span>Secure checkout powered by Stripe</span>
        </div>
      </motion.div>

      {/* Pricing Cards */}
      <div className="mt-6">
        <PricingCards />
      </div>
    </div>
  );
}
